import { FormErrors } from 'KnmPackage/MainModule/types/FormErrors';
import { makeRequired } from 'CorePackage/MainModule/validators/isRequired';
import { makeNoLaterThenValidator } from 'CorePackage/MainModule/validators/isNoLaterThen';
import { makeNoSoonerThenValidator } from 'CorePackage/MainModule/validators/isNoSoonerThan';
import { composeValidators } from 'CorePackage/MainModule/validators/composeValidators';

import { IKnmErknmFormEvent } from '../interfaces/IKnmErknmFormEvent';
import { IKnmErknmFormInspector } from '../interfaces/IKnmErknmFormInspector';
import { getEventInspectorsValidate } from './getEventInspectorsValidate';
import { getActEventProtocolValidator } from './getActEventProtocolValidator';
import { IKnmErknmFormSuspensionEvent } from '../interfaces/IKnmErknmFormSuspensionEvent';
import { isBooleanTrue } from '../../../CorePackage/MainModule/validators/isBooleanTrue';
import { checkIntersectionValidateForSuspensionEvents } from '../../../functions/checkIntersectionValidateForSuspensionEvents';
import { getEventUavValidator } from './getEventUavValidate';

export const getActEventValidator = (
  item: IKnmErknmFormEvent,
  holdingDateTime?: string,
  inspectorsErknm?: IKnmErknmFormInspector[],
  isInteractionCategoryOrInspectorRequired?: boolean,
  isKnmStatusTypeCompleted?: boolean,
  isPm?: boolean,
  eventsErknm?: IKnmErknmFormEvent[],
  suspensionEventsForActEvent?: IKnmErknmFormSuspensionEvent[],
): FormErrors<IKnmErknmFormEvent> => {
  const isWithoutAction = item.type?.label === 'Осуществляется без действия';
  let isShowVksFields: boolean | undefined;
  let knmEvent: IKnmErknmFormEvent | undefined;

  if (item.type?.label) {
    knmEvent = eventsErknm?.find(i => i.type?.title === item.type?.label);

    isShowVksFields = knmEvent?.interactionCategory && knmEvent.interactionCategory.id === 1;
  }

  const { isValidStartDate, isValidStopDate } = checkIntersectionValidateForSuspensionEvents({
    item,
    suspensionEventsForActEvent,
  });

  return {
    type: makeRequired('Поле не может быть пустым')(item.type),
    inspectors:
      inspectorsErknm && isInteractionCategoryOrInspectorRequired && !item.actionNotPerformed
        ? getEventInspectorsValidate(item.inspectors, isKnmStatusTypeCompleted)
        : undefined,
    startDate: item.actionNotPerformed
      ? undefined
      : composeValidators(
          makeNoLaterThenValidator('Дата начала не должна быть позже даты окончания', () => item.stopDate),
          makeRequired('Поле не может быть пустым', () => isWithoutAction),
          makeNoLaterThenValidator(
            `Дата начала действия не должна быть позже даты окончания действия ${isPm ? 'ПМ' : 'КНМ'}`,
            () => knmEvent?.stopDate,
          ),
          makeNoSoonerThenValidator(
            `Дата начала действия не должна быть раньше даты начала действия ${isPm ? 'ПМ' : 'КНМ'}`,
            () => knmEvent?.startDate,
          ),
          makeNoSoonerThenValidator(
            `Дата начала действия в акте должна быть больше или равна дате начала проведения ${
              isPm ? 'ПМ' : 'КНМ'
            } в акте`,
            () => holdingDateTime,
          ),
          () =>
            isBooleanTrue('Дата начала действия должна учитывать даты приостановки')(isPm ? !isValidStartDate : false),
        )(item.startDate),
    stopDate: item.actionNotPerformed
      ? undefined
      : composeValidators(
          makeNoSoonerThenValidator('Дата окончания не должна быть раньше даты начала', () => item.startDate),
          makeRequired('Поле не может быть пустым', () => isWithoutAction),
          makeNoLaterThenValidator(
            `Дата окончания действия не должна быть позже даты окончания действия ${isPm ? 'ПМ' : 'КНМ'}`,
            () => knmEvent?.stopDate,
          ),
          makeNoSoonerThenValidator(
            'Дата окончания должна быть больше или равна дате начала осуществленного действия',
            () => holdingDateTime,
          ),

          () =>
            isBooleanTrue('Дата окончания действия должна учитывать даты приостановки')(
              isPm ? !isValidStopDate : false,
            ),
        )(item.stopDate),
    linkVks:
      !item.actionNotPerformed && isShowVksFields ? makeRequired('Поле не может быть пустым')(item.linkVks) : undefined,
    protocol: getActEventProtocolValidator(item),
    uavTechnologies:
      item.isUavUsed === true ? getEventUavValidator(item.uavTechnologies, isKnmStatusTypeCompleted) : undefined,
  };
};
